/* eslint-disable */
const axios = require('axios').default;
import apiosWithToken from "./apiosWithToken"

export default {
    getScriptCircuits(id) {
        return apiosWithToken.get(`/activities/${id}/scripts/`)
    },
    getScriptCircuitsAutoCue(id) {
        return apiosWithToken.get(`/activities/${id}/scripts/auto-cue/`)
    },
    getScriptCircuitsAutoCueWithRests(id) {
        return apiosWithToken.get(`/activities/${id}/scripts/auto-cue/?with_rests=true/`)
    },
    getScriptCircuitsAutoCueWithRestsAndCircuitDetails(id) {
        return apiosWithToken.get(`/activities/${id}/scripts/auto-cue/?with_rests=true&with_circuit=true`)
    },
    
    createCircuit(payload) {
        return apiosWithToken.post(`/activities/${payload.activity}/scripts/`, payload)
    },
    updateCircuit(payload) {
        return apiosWithToken.patch(`/activities/${payload.activity}/scripts/${payload.id}/`, payload)
    },
    deleteScriptItem(id) {
        return apiosWithToken.delete(`/activities/scripts/items/${id}`)
    },
    deleteScriptCircuit(activity, id) {
        return apiosWithToken.delete(`/activities/${activity}/scripts/${id}`)
    },
    
    updateScriptItem(id, payload) {
        return apiosWithToken.put(`/activities/scripts/items/${id}/`, payload)
    },        
}